import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { volumes } from '../../data/content';
export function VolumesSection() {
  return <section aria-labelledby="volumes-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-183" data-mp="hvgl64lgx6wp">
      <div className="mx-auto max-w-6xl" data-id="element-184" data-mp="3zv20e1x1hc7">
        <SectionHeading id="volumes-heading" title={<>
              6 Practical Volumes. <Accent data-id="element-186" data-mp="vpzi40in7i7m">One Complete Teaching System.</Accent>
            </>} data-id="element-185" data-mp="7yu47qw9izzy" />

        <ol className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" role="list" data-id="element-187" data-mp="10oatwgsi02sh">
          {volumes.map(volume => <li key={volume.number} className="flex h-full flex-col overflow-hidden rounded-[22px] bg-white shadow-[0_24px_50px_-36px_rgba(24,45,42,0.45)] ring-1 ring-brand-gold/25" data-id="element-188" data-mp="mw4lxhzi1244">
              <div className="relative flex min-h-[170px] flex-col px-6 pb-6 pt-5" style={{
            backgroundColor: volume.accent
          }} data-id="element-189" data-mp="1elpn7wlvgupq">
                <span aria-hidden="true" className="pointer-events-none absolute right-5 top-2 font-script text-[3.5rem] leading-none text-white/80" data-id="element-190" data-mp="ckzw0jqkgbaz">
                  {volume.number}
                </span>
                <span className="relative self-start rounded-full bg-white/80 px-3 py-1 font-body text-[10px] font-bold uppercase tracking-[0.2em] text-brand-charcoal/80" data-id="element-191" data-mp="mcduqpap1732">
                  Volume {volume.number}
                </span>
                <h3 className="relative mt-auto pt-5 font-display text-[1.4rem] font-bold leading-[1.12] text-brand-charcoal" data-id="element-192" data-mp="rafkft2mk4ni">
                  {volume.title}
                </h3>
              </div>
              <div className="flex flex-1 flex-col px-6 py-5" data-id="element-193" data-mp="10b3r22pov2qd">
                <span aria-hidden="true" className="block h-px w-10 bg-brand-gold/60" data-id="element-194" data-mp="108r9vrrr8wed" />
                <p className="mt-3 text-[14px] leading-relaxed text-brand-charcoal/70" data-id="element-195" data-mp="371jyo5k5z4r8">{volume.description}</p>
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-8 max-w-2xl text-center text-[13px] leading-relaxed text-brand-charcoal/60" data-id="element-196" data-mp="1603zckqbko1m">
          Digital PDF resources. Assessment and completion materials are for classroom organization only — they are
          not official certification, accreditation, or licensing.
        </p>
      </div>
    </section>;
}